export default __webpack_public_path__ + "static/Map-b476dac86ef5d62954782f9c43e6e97b.webp";